var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinanceI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 351.83,
    cy: 132.5,
    rx: 18.15,
    ry: 21.27,
    transform: "translate(-6.03 17.27) rotate(-2.79)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,131.77c.47,9.7-5.85,17.89-14.13,18.3s-15.37-7.14-15.84-16.84,5.85-17.89,14.13-18.29S366.34,122.07,366.81,131.77Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.32,141.65l.14,2.88-1.8.09-.14-2.85A8.77,8.77,0,0,1,346,139.9l.86-2.65a7.76,7.76,0,0,0,4.48,1.74l-.25-5.14c-2.47-.58-5.12-1.37-5.3-4.95-.12-2.62,1.39-5,4.79-5.54l-.14-2.91,1.8-.08.14,2.85a8.44,8.44,0,0,1,4.53,1.35l-.78,2.64a8.22,8.22,0,0,0-3.62-1.21l.26,5.19c2.46.58,5.16,1.35,5.34,4.92C358.27,138.73,356.74,141.08,353.32,141.65ZM351,130.74l-.22-4.58a2.32,2.32,0,0,0-2.1,2.45C348.72,129.84,349.69,130.36,351,130.74Zm4.37,5.74c-.06-1.26-1.06-1.8-2.39-2.18l.22,4.55C354.77,138.49,355.4,137.58,355.35,136.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.62,
    cy: 325.62,
    rx: 18.15,
    ry: 21.27,
    transform: "translate(-15.7 6.4) rotate(-2.79)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.61,324.89c.47,9.7-5.86,17.89-14.13,18.29s-15.37-7.13-15.84-16.83,5.85-17.89,14.12-18.3S138.13,315.19,138.61,324.89Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.11,334.77l.14,2.88-1.8.09-.14-2.86a8.74,8.74,0,0,1-5.47-1.87l.86-2.64a7.78,7.78,0,0,0,4.48,1.74l-.25-5.15c-2.47-.57-5.13-1.37-5.3-4.94-.13-2.63,1.38-5,4.79-5.55l-.15-2.9,1.8-.09.14,2.86a8.35,8.35,0,0,1,4.53,1.35l-.77,2.64a8.24,8.24,0,0,0-3.62-1.22l.25,5.2c2.47.57,5.17,1.34,5.34,4.92C130.07,331.85,128.53,334.19,125.11,334.77Zm-2.33-10.92-.23-4.57a2.33,2.33,0,0,0-2.1,2.44C120.51,323,121.48,323.48,122.78,323.85Zm4.37,5.74c-.07-1.26-1.06-1.8-2.4-2.17L125,332C126.56,331.61,127.2,330.7,127.15,329.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.58,
    cy: 225.32,
    rx: 18.15,
    ry: 21.27,
    transform: "translate(3.1 455.72) rotate(-62.84)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.58,
    cy: 225.32,
    rx: 15,
    ry: 17.58,
    transform: "translate(3.1 455.72) rotate(-62.84)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,228.6l2.56,1.31-.82,1.61-2.54-1.31A8.7,8.7,0,0,1,378.1,234L376.24,232a7.84,7.84,0,0,0,3.75-3l-4.58-2.35c-1.74,1.85-3.75,3.76-6.94,2.12-2.33-1.2-3.63-3.69-2.41-6.91l-2.59-1.33.83-1.6,2.54,1.3a8.48,8.48,0,0,1,3.43-3.25l1.9,2a8.26,8.26,0,0,0-2.86,2.53l4.63,2.37c1.73-1.85,3.74-3.8,6.93-2.17C383.2,222.84,384.47,225.34,383.26,228.6Zm-10.62-3.43-4.08-2.09a2.32,2.32,0,0,0,1.07,3C370.73,226.68,371.66,226.1,372.64,225.17Zm7.15-.92c-1.12-.58-2.09,0-3.08,1l4.05,2.08C381.24,225.76,380.77,224.76,379.79,224.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.07,196.8a21.51,21.51,0,1,1-22.52-20.19A21.38,21.38,0,0,1,319.07,196.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35,197a17.78,17.78,0,1,1-18.62-16.69A17.68,17.68,0,0,1,315.35,197Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.27,207l.14,2.88-2.13.11-.14-2.86a11.49,11.49,0,0,1-6.47-1.82l1-2.65a10.2,10.2,0,0,0,5.3,1.7l-.25-5.14c-2.92-.56-6.06-1.33-6.24-4.91-.12-2.62,1.69-5,5.72-5.58l-.14-2.91,2.13-.1.14,2.85a11.3,11.3,0,0,1,5.36,1.31l-.94,2.65a10.77,10.77,0,0,0-4.28-1.18l.25,5.19c2.92.55,6.11,1.3,6.28,4.87C305.17,204,303.33,206.38,299.27,207Zm-2.67-10.9-.22-4.57c-1.83.37-2.57,1.33-2.51,2.47S295.08,195.73,296.6,196.09Zm5.13,5.71c-.06-1.26-1.24-1.8-2.82-2.16l.22,4.55C301,203.82,301.78,202.9,301.73,201.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.5,
    cy: 291.85,
    rx: 21.5,
    ry: 21.27,
    transform: "translate(-13.98 9.96) rotate(-2.79)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.5,
    cy: 291.85,
    rx: 17.78,
    ry: 17.58,
    transform: "translate(-13.97 9.96) rotate(-2.79)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.18,301l.14,2.88-2.13.1-.14-2.85a11.49,11.49,0,0,1-6.47-1.82l1-2.66a10,10,0,0,0,5.3,1.7l-.25-5.14c-2.92-.55-6.06-1.33-6.24-4.9-.12-2.62,1.69-5,5.72-5.59l-.14-2.9,2.13-.11.14,2.86a11.19,11.19,0,0,1,5.36,1.31l-.94,2.64a10.94,10.94,0,0,0-4.28-1.18l.25,5.19c2.92.56,6.11,1.31,6.28,4.88C205.08,298,203.24,300.39,199.18,301Zm-2.67-10.9-.22-4.58c-1.83.38-2.56,1.34-2.51,2.47S195,289.74,196.51,290.1Zm5.13,5.7c-.06-1.26-1.24-1.79-2.82-2.15l.23,4.55C200.93,297.82,201.69,296.91,201.64,295.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.85,
    cy: 233.11,
    rx: 21.5,
    ry: 21.27,
    transform: "translate(-98.57 77.71) rotate(-28.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,224.63a17.78,17.78,0,1,1-24-7A17.69,17.69,0,0,1,119.48,224.63Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.33,240.62l1.38,2.54-1.88,1-1.36-2.51a11.4,11.4,0,0,1-6.62,1.16l-.21-2.84a10,10,0,0,0,5.5-.76l-2.45-4.53c-2.87.77-6,1.43-7.74-1.71-1.25-2.31-.65-5.24,2.73-7.52l-1.38-2.55,1.87-1,1.36,2.51a11.28,11.28,0,0,1,5.4-1.14l.3,2.79a10.94,10.94,0,0,0-4.37.79l2.48,4.57c2.87-.76,6.07-1.47,7.77,1.67C113.36,235.39,112.73,238.31,109.33,240.62ZM102.2,232l-2.18-4c-1.49,1.13-1.73,2.32-1.19,3.31S100.67,232.29,102.2,232Zm7.09,2.91c-.6-1.1-1.89-1.08-3.47-.72l2.18,4C109.53,237,109.82,235.85,109.29,234.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68,208.41A15.46,15.46,0,1,1,157.24,201,15.37,15.37,0,0,1,177.68,208.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.63,
    cy: 214.86,
    rx: 12.78,
    ry: 12.64,
    transform: "translate(-74.8 88.01) rotate(-24.69)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.21,220.51l.86,1.88-1.39.64-.86-1.86a8.27,8.27,0,0,1-4.8.52l0-2.05a7.21,7.21,0,0,0,4-.29L163.44,216c-2.09.42-4.39.74-5.47-1.6-.79-1.71-.22-3.78,2.32-5.26l-.88-1.9,1.4-.64.85,1.87a8.08,8.08,0,0,1,3.93-.56l.08,2a7.81,7.81,0,0,0-3.17.35l1.56,3.4c2.1-.41,4.42-.77,5.5,1.57C170.35,217,169.75,219,167.21,220.51Zm-4.7-6.55-1.38-3c-1.12.74-1.35,1.58-1,2.31S161.39,214.13,162.51,214Zm4.94,2.43c-.38-.83-1.3-.87-2.45-.69l1.37,3C167.52,217.92,167.78,217.11,167.45,216.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5,341.33a15.45,15.45,0,1,1-20.43-7.43A15.36,15.36,0,0,1,376.5,341.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.46,
    cy: 347.79,
    rx: 12.78,
    ry: 12.64,
    transform: "translate(-112.19 183.36) rotate(-24.71)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,353.43l.87,1.88-1.39.65-.86-1.87a8.3,8.3,0,0,1-4.81.52v-2.05a7.17,7.17,0,0,0,4-.29l-1.54-3.36c-2.1.42-4.4.74-5.47-1.6-.79-1.71-.22-3.78,2.31-5.26l-.87-1.89,1.39-.65.86,1.87a8,8,0,0,1,3.92-.56l.09,2a7.62,7.62,0,0,0-3.17.36l1.56,3.39c2.09-.41,4.42-.77,5.49,1.57C369.17,349.87,368.58,351.94,366,353.43Zm-4.7-6.55-1.38-3c-1.12.74-1.35,1.58-1,2.32S360.21,347.05,361.33,346.88Zm4.95,2.43c-.38-.83-1.31-.87-2.46-.69l1.37,3C366.35,350.84,366.61,350,366.28,349.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.32,353.12a15.46,15.46,0,1,1-20.44-7.43A15.38,15.38,0,0,1,271.32,353.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.27,
    cy: 359.58,
    rx: 12.78,
    ry: 12.64,
    transform: "translate(-126.69 140.36) rotate(-24.69)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.85,365.23l.86,1.88-1.39.64-.86-1.87a8.19,8.19,0,0,1-4.8.52l0-2a7.3,7.3,0,0,0,4-.28l-1.55-3.36c-2.09.41-4.39.74-5.47-1.6-.79-1.72-.22-3.79,2.32-5.26l-.88-1.9,1.4-.64.86,1.86a8.15,8.15,0,0,1,3.92-.56l.08,2a7.81,7.81,0,0,0-3.17.36l1.56,3.39c2.1-.41,4.42-.77,5.5,1.57C264,361.66,263.39,363.73,260.85,365.23Zm-4.7-6.56-1.38-3c-1.12.74-1.35,1.58-1,2.32S255,358.84,256.15,358.67Zm4.94,2.43c-.38-.82-1.3-.86-2.45-.68l1.37,3C261.16,362.64,261.42,361.82,261.09,361.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.93,96.46A14.31,14.31,0,1,1,254,89.59,14.22,14.22,0,0,1,272.93,96.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,97.5a11.82,11.82,0,1,1-15.63-5.69A11.76,11.76,0,0,1,270.68,97.5Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,107.66l.8,1.75-1.29.59-.8-1.73a7.52,7.52,0,0,1-4.44.48l0-1.89a6.68,6.68,0,0,0,3.69-.27l-1.43-3.11c-1.94.39-4.07.69-5.06-1.48-.73-1.58-.2-3.5,2.14-4.86L256,95.38l1.29-.59.8,1.72a7.56,7.56,0,0,1,3.63-.52l.07,1.87a7.2,7.2,0,0,0-2.93.33l1.44,3.14c1.94-.38,4.1-.71,5.09,1.45C266.15,104.37,265.6,106.28,263.25,107.66Zm-4.35-6.06-1.28-2.77c-1,.69-1.25,1.46-.94,2.15S257.86,101.75,258.9,101.6Zm4.57,2.25c-.35-.76-1.2-.8-2.27-.63l1.27,2.75C263.54,105.27,263.78,104.52,263.47,103.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.11,
    cy: 148.82,
    rx: 11.84,
    ry: 13.87,
    transform: "translate(-43.67 119.85) rotate(-27.6)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.78,144.28c2.94,5.62,1.44,12.2-3.35,14.7s-11.05,0-14-5.63-1.43-12.19,3.36-14.7S227.85,138.67,230.78,144.28Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,153.83l.87,1.66-1,.55-.86-1.65a5.76,5.76,0,0,1-3.76.39l-.21-1.8a5.07,5.07,0,0,0,3.13-.2l-1.56-3c-1.62.34-3.41.59-4.49-1.48a3.38,3.38,0,0,1,1.32-4.59l-.88-1.68,1-.54.86,1.65a5.55,5.55,0,0,1,3.05-.44l.27,1.77a5.4,5.4,0,0,0-2.48.28l1.57,3c1.62-.33,3.43-.62,4.51,1.45A3.4,3.4,0,0,1,225.5,153.83ZM221.13,148l-1.39-2.65a1.53,1.53,0,0,0-.57,2C219.54,148.09,220.26,148.14,221.13,148Zm4.16,2.21c-.38-.73-1.12-.78-2-.64l1.38,2.64A1.51,1.51,0,0,0,225.29,150.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.3,107l3.22,1.41c9.17,4,12.78,16,8.06,26.76s-16,16.22-25.16,12.19L149.21,146c-9.18-4-12.79-16-8.07-26.77S157.13,103,166.3,107Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,119.18c-4.72,10.75-1.11,22.74,8.07,26.77s20.44-1.43,25.16-12.19S175.48,111,166.3,107,145.86,108.42,141.14,119.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.75,
    cy: 126.47,
    rx: 17.58,
    ry: 15,
    transform: "translate(-21.46 220.09) rotate(-66.3)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,135.33,153.85,138l-1.65-.73,1.15-2.61a8.77,8.77,0,0,1-4.07-4.12l1.95-2a7.75,7.75,0,0,0,3.23,3.55l2.07-4.71c-1.95-1.62-4-3.52-2.53-6.79,1.05-2.41,3.46-3.85,6.75-2.83l1.17-2.66,1.65.72-1.15,2.62a8.43,8.43,0,0,1,3.45,3.23l-1.87,2a8.19,8.19,0,0,0-2.69-2.71l-2.09,4.77c1.95,1.61,4,3.51,2.58,6.78C160.75,134.93,158.33,136.34,155,135.33Zm2.77-10.81,1.85-4.2a2.34,2.34,0,0,0-3,1.25C156.16,122.71,156.79,123.6,157.78,124.52Zm1.35,7.08c.51-1.15-.14-2.08-1.17-3l-1.83,4.17C157.72,133.14,158.69,132.62,159.13,131.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.87,266.55l2.23,1c6.37,2.79,8.88,11.11,5.61,18.58s-11.1,11.25-17.47,8.46l-2.23-1c-6.37-2.8-8.88-11.12-5.6-18.58S413.5,263.75,419.87,266.55Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.41,275c-3.28,7.46-.77,15.78,5.6,18.58s14.19-1,17.46-8.46.77-15.79-5.6-18.58S405.68,267.54,402.41,275Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.4,275.88c-2.71,6.18-.63,13.05,4.63,15.37s11.74-.82,14.45-7,.63-13.05-4.63-15.36S407.11,269.71,404.4,275.88Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,286.22l-.8,1.83-1.15-.5.8-1.82a6.06,6.06,0,0,1-2.82-2.86l1.35-1.38a5.39,5.39,0,0,0,2.25,2.47l1.43-3.27c-1.35-1.12-2.76-2.44-1.76-4.71a3.59,3.59,0,0,1,4.69-2l.81-1.85,1.15.5-.8,1.82a5.79,5.79,0,0,1,2.4,2.24l-1.3,1.4a5.88,5.88,0,0,0-1.87-1.88L415,279.56c1.35,1.12,2.79,2.43,1.79,4.71A3.62,3.62,0,0,1,412,286.22Zm1.93-7.51,1.28-2.91a1.6,1.6,0,0,0-2.06.87C412.83,277.45,413.27,278.08,414,278.71Zm.94,4.92c.35-.8-.1-1.45-.81-2.09l-1.28,2.89A1.61,1.61,0,0,0,414.9,283.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.54,267l3.21,1.41c9.18,4,12.79,16,8.07,26.77s-16,16.21-25.17,12.18L278.44,306c-9.17-4-12.79-16-8.07-26.77S286.36,263,295.54,267Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.37,279.2c-4.72,10.76-1.1,22.74,8.07,26.77s20.45-1.43,25.17-12.18S304.72,271,295.54,267,275.1,268.44,270.37,279.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.25,280.46c-3.9,8.9-.91,18.8,6.67,22.13s16.9-1.18,20.81-10.07.92-18.8-6.67-22.13S277.16,271.57,273.25,280.46Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.24,295.35,283.08,298l-1.65-.72,1.15-2.62a8.82,8.82,0,0,1-4.07-4.12l1.95-2a7.78,7.78,0,0,0,3.24,3.55l2.07-4.71c-1.95-1.62-4-3.51-2.54-6.79,1.06-2.41,3.47-3.85,6.76-2.83l1.17-2.66,1.65.72-1.15,2.62a8.43,8.43,0,0,1,3.45,3.23l-1.87,2a8,8,0,0,0-2.7-2.7l-2.09,4.76c2,1.61,4,3.51,2.59,6.78C290,295,287.57,296.36,284.24,295.35ZM287,284.54l1.84-4.2a2.33,2.33,0,0,0-3,1.26C285.39,282.73,286,283.63,287,284.54Zm1.35,7.08c.51-1.15-.14-2.08-1.17-3l-1.83,4.17C287,293.17,287.93,292.64,288.37,291.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,111.26l-3.5.17c-10,.49-17.67,10.39-17.09,22.13s9.15,20.84,19.16,20.36l3.5-.17c10-.49,17.66-10.4,17.09-22.13S360.8,110.77,350.79,111.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.59,304.37l-3.51.17c-10,.49-17.66,10.4-17.09,22.13s9.15,20.85,19.16,20.36l3.51-.17c10-.49,17.66-10.39,17.09-22.13S132.6,303.88,122.59,304.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.66,215.61l-1.6,3.12c-4.58,8.92.19,20.49,10.64,25.85s22.63,2.49,27.21-6.43c.12-.24,1.47-2.88,1.6-3.12,4.57-8.92-.19-20.49-10.64-25.86S360.24,206.69,355.66,215.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.68,136.52l-2,1.06c-5.8,3-7.61,11-4.06,17.78s11.12,9.84,16.91,6.81l2-1.06c5.79-3,7.61-11,4.06-17.78S221.48,133.49,215.68,136.52Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-7",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184,384.06l-4.3,4.84a1.13,1.13,0,0,1-1.56.09l-21.58-19.2a1.1,1.1,0,0,1-.09-1.56l4.3-4.83a.93.93,0,0,1,.27-.22,1.09,1.09,0,0,1,1.29.13l21.58,19.19a1.09,1.09,0,0,1,.27,1.26A.78.78,0,0,1,184,384.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,384.06l-4.3,4.84a1.13,1.13,0,0,1-1.56.09l-21.58-19.2a1.1,1.1,0,0,1-.09-1.56l4.3-4.83a.93.93,0,0,1,.27-.22,1.09,1.09,0,0,1,1.29.13l21.58,19.19a1.09,1.09,0,0,1,.27,1.26A.78.78,0,0,1,184,384.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,387.56l3.91-4.39a.38.38,0,1,0-.56-.5l-3.91,4.4L176.63,386l3.91-4.4a.37.37,0,1,0-.55-.5l-3.92,4.4-1.26-1.12,3.91-4.4a.37.37,0,1,0-.55-.49l-3.92,4.39L173,382.71l3.92-4.4a.37.37,0,0,0-.56-.49l-3.91,4.4-1.27-1.12,3.92-4.4a.39.39,0,0,0,0-.53.38.38,0,0,0-.53,0l-3.91,4.4-1.26-1.12,3.91-4.4a.38.38,0,0,0,0-.53.39.39,0,0,0-.53,0L168.8,379l-1.26-1.12,3.91-4.4a.37.37,0,0,0-.56-.49l-3.91,4.4-1.26-1.12,3.91-4.4a.37.37,0,1,0-.55-.5l-3.92,4.4-1.26-1.12,3.91-4.4a.37.37,0,0,0,0-.53.37.37,0,0,0-.52,0l-3.92,4.4-1.23-1.1,0,0,3.91-4.4a.37.37,0,0,0,0-.52.37.37,0,0,0-.53,0l-3.69,4.14a1.09,1.09,0,0,1,.29-.77l2.63-3.1a1.09,1.09,0,0,0-.07-1.58l-3-2.7a1.13,1.13,0,0,0-1.58.08l-3.53,4.06a1.08,1.08,0,0,0,.07,1.55L178.1,389a1.14,1.14,0,0,0,1.59-.09l.11-.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,383.76,161,363.18a1.09,1.09,0,0,1,1.29.13l21.58,19.19A1.09,1.09,0,0,1,184.14,383.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,407.51V414a1.1,1.1,0,0,1-1.1,1.1H89.53a1.11,1.11,0,0,1-1.11-1.1v-6.47a1,1,0,0,1,.06-.35,1.09,1.09,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.83.83,0,0,1,119.51,407.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,407.51V414a1.1,1.1,0,0,1-1.1,1.1H89.53a1.11,1.11,0,0,1-1.11-1.1v-6.47a1,1,0,0,1,.06-.35,1.09,1.09,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.83.83,0,0,1,119.51,407.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.72,413.79V407.9a.37.37,0,1,0-.74,0v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.89h-1.68V407.9a.38.38,0,0,0-.75,0v5.89h-1.69V407.9a.37.37,0,1,0-.74,0v5.89H108V407.9a.38.38,0,0,0-.75,0v5.89h-1.68V407.9a.38.38,0,0,0-.75,0v5.89h-1.69V407.9a.37.37,0,0,0-.74,0v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.89H98.26V407.9a.38.38,0,0,0-.75,0v5.89H95.82V407.9a.37.37,0,0,0-.74,0v5.55a1.06,1.06,0,0,1-.3-.77l-.1-4.07a1.09,1.09,0,0,0-1.09-1.13H89.52a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11H118.4a1.15,1.15,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,407.16h-31a1.09,1.09,0,0,1,1-.76h28.88A1.11,1.11,0,0,1,119.45,407.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,398.7v6.47a1.11,1.11,0,0,1-1.1,1.11H87.53a1.11,1.11,0,0,1-1.11-1.11V398.7a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,398.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,398.7v6.47a1.11,1.11,0,0,1-1.1,1.11H87.53a1.11,1.11,0,0,1-1.11-1.11V398.7a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,398.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,405V399.1a.37.37,0,1,0-.74,0V405h-1.69V399.1a.38.38,0,1,0-.75,0V405h-1.68V399.1a.38.38,0,1,0-.75,0V405h-1.69V399.1a.37.37,0,1,0-.74,0V405H106V399.1a.38.38,0,1,0-.75,0V405h-1.68V399.1a.38.38,0,1,0-.75,0V405h-1.69V399.1a.37.37,0,1,0-.74,0V405H98.69V399.1a.38.38,0,1,0-.75,0V405H96.26V399.1a.38.38,0,1,0-.75,0V405H93.82V399.1a.37.37,0,1,0-.74,0v5.55a1.09,1.09,0,0,1-.3-.78l-.1-4.06a1.09,1.09,0,0,0-1.1-1.14H87.52a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11H116.4a1.15,1.15,0,0,0,1.13-1.12V405Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,398.36h-31a1.08,1.08,0,0,1,1-.76h28.88A1.1,1.1,0,0,1,117.45,398.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,389.9v6.47a1.1,1.1,0,0,1-1.1,1.1H87.53a1.1,1.1,0,0,1-1.11-1.1V389.9a1,1,0,0,1,.06-.35,1.09,1.09,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.83.83,0,0,1,117.51,389.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,389.9v6.47a1.1,1.1,0,0,1-1.1,1.1H87.53a1.1,1.1,0,0,1-1.11-1.1V389.9a1,1,0,0,1,.06-.35,1.09,1.09,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.83.83,0,0,1,117.51,389.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,396.18v-5.89a.37.37,0,1,0-.74,0v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,1,0-.74,0v5.89H106v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.74,0v5.89H98.69v-5.89a.38.38,0,0,0-.75,0v5.89H96.26v-5.89a.38.38,0,0,0-.75,0v5.89H93.82v-5.88a.37.37,0,0,0-.74,0v5.55a1.06,1.06,0,0,1-.3-.77l-.1-4.07a1.09,1.09,0,0,0-1.1-1.13H87.52A1.14,1.14,0,0,0,86.39,391l.07,5.38a1.07,1.07,0,0,0,1.07,1.11H116.4a1.15,1.15,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,389.55h-31a1.09,1.09,0,0,1,1-.76h28.88A1.11,1.11,0,0,1,117.45,389.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,381.09v6.47a1.11,1.11,0,0,1-1.1,1.11H87.53a1.1,1.1,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,381.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,381.09v6.47a1.11,1.11,0,0,1-1.1,1.11H87.53a1.1,1.1,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,381.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,387.37v-5.88a.37.37,0,1,0-.74,0v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88H106v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88H98.69v-5.88a.38.38,0,1,0-.75,0v5.88H96.26v-5.88a.38.38,0,1,0-.75,0v5.88H93.82v-5.88a.37.37,0,1,0-.74,0V387a1.07,1.07,0,0,1-.3-.78l-.1-4.06a1.09,1.09,0,0,0-1.1-1.13H87.52a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11H116.4a1.15,1.15,0,0,0,1.13-1.13v-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,380.75h-31a1.08,1.08,0,0,1,1-.76h28.88A1.1,1.1,0,0,1,117.45,380.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,372.29v6.47a1.11,1.11,0,0,1-1.1,1.1H85.52a1.1,1.1,0,0,1-1.1-1.1v-6.47a1,1,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.89a1.12,1.12,0,0,1,1,.76A.83.83,0,0,1,115.51,372.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,372.29v6.47a1.11,1.11,0,0,1-1.1,1.1H85.52a1.1,1.1,0,0,1-1.1-1.1v-6.47a1,1,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.89a1.12,1.12,0,0,1,1,.76A.83.83,0,0,1,115.51,372.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.72,378.57v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89H104v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89H99.12v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89H96.69v-5.89a.38.38,0,0,0-.75,0v5.89H94.25v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89H91.82v-5.88a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.55a1.06,1.06,0,0,1-.3-.77l-.1-4.06a1.09,1.09,0,0,0-1.1-1.14H85.52a1.14,1.14,0,0,0-1.13,1.11l.06,5.38a1.08,1.08,0,0,0,1.08,1.11H114.4a1.15,1.15,0,0,0,1.13-1.12v-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.45,371.94h-31a1.08,1.08,0,0,1,1-.76h28.89A1.12,1.12,0,0,1,115.45,371.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,363.48V370a1.11,1.11,0,0,1-1.1,1.11H87.53A1.1,1.1,0,0,1,86.42,370v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,363.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,363.48V370a1.11,1.11,0,0,1-1.1,1.11H87.53A1.1,1.1,0,0,1,86.42,370v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,363.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,369.77v-5.89a.37.37,0,0,0-.74,0v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,1,0-.74,0v5.89H106v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.74,0v5.89H98.69v-5.89a.38.38,0,0,0-.75,0v5.89H96.26v-5.89a.38.38,0,0,0-.75,0v5.89H93.82v-5.88a.37.37,0,0,0-.74,0v5.55a1.06,1.06,0,0,1-.3-.77l-.1-4.07a1.09,1.09,0,0,0-1.1-1.13H87.52a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11H116.4a1.15,1.15,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,363.14h-31a1.08,1.08,0,0,1,1-.76h28.88A1.1,1.1,0,0,1,117.45,363.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,354.68v6.47a1.1,1.1,0,0,1-1.1,1.1H87.53a1.1,1.1,0,0,1-1.11-1.1v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,354.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,354.68v6.47a1.1,1.1,0,0,1-1.1,1.1H87.53a1.1,1.1,0,0,1-1.11-1.1v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,354.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,361v-5.89a.37.37,0,0,0-.74,0V361h-1.69v-5.89a.38.38,0,0,0-.75,0V361h-1.68v-5.89a.38.38,0,0,0-.75,0V361h-1.69v-5.89a.37.37,0,0,0-.74,0V361H106v-5.89a.38.38,0,0,0-.75,0V361h-1.68v-5.89a.38.38,0,0,0-.75,0V361h-1.69v-5.89a.37.37,0,0,0-.74,0V361H98.69v-5.89a.38.38,0,0,0-.75,0V361H96.26v-5.89a.38.38,0,0,0-.75,0V361H93.82v-5.88a.37.37,0,0,0-.74,0v5.56a1.09,1.09,0,0,1-.3-.78l-.1-4.06a1.09,1.09,0,0,0-1.1-1.14H87.52a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11H116.4a1.15,1.15,0,0,0,1.13-1.12V361Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,354.34h-31a1.08,1.08,0,0,1,1-.76h28.88A1.1,1.1,0,0,1,117.45,354.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,345.87v6.48a1.11,1.11,0,0,1-1.1,1.1H85.52a1.1,1.1,0,0,1-1.1-1.1v-6.48a1,1,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.89a1.11,1.11,0,0,1,1,.76A.82.82,0,0,1,115.51,345.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,345.87v6.48a1.11,1.11,0,0,1-1.1,1.1H85.52a1.1,1.1,0,0,1-1.1-1.1v-6.48a1,1,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.89a1.11,1.11,0,0,1,1,.76A.82.82,0,0,1,115.51,345.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.72,352.16v-5.89a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.36.36,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.89H104v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.36.36,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89H99.12v-5.89a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.89H96.69v-5.89a.38.38,0,0,0-.75,0v5.89H94.25v-5.89a.36.36,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89H91.82v-5.88a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.55a1.06,1.06,0,0,1-.3-.77l-.1-4.07a1.09,1.09,0,0,0-1.1-1.13H85.52A1.14,1.14,0,0,0,84.39,347l.06,5.38a1.08,1.08,0,0,0,1.08,1.11H114.4a1.16,1.16,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.45,345.53h-31a1.07,1.07,0,0,1,1-.76h28.89A1.11,1.11,0,0,1,115.45,345.53Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,337.07v6.47a1.11,1.11,0,0,1-1.1,1.11H87.53a1.11,1.11,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,337.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,337.07v6.47a1.11,1.11,0,0,1-1.1,1.11H87.53a1.11,1.11,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.08,1.08,0,0,1,1-.76h28.88a1.1,1.1,0,0,1,1,.76A.76.76,0,0,1,117.51,337.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,343.35v-5.88a.37.37,0,1,0-.74,0v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88H106v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88H98.69v-5.88a.38.38,0,1,0-.75,0v5.88H96.26v-5.88a.38.38,0,1,0-.75,0v5.88H93.82v-5.88a.37.37,0,1,0-.74,0V343a1.09,1.09,0,0,1-.3-.78l-.1-4.06a1.09,1.09,0,0,0-1.1-1.14H87.52a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11H116.4a1.15,1.15,0,0,0,1.13-1.12v-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,336.73h-31a1.08,1.08,0,0,1,1-.76h28.88A1.1,1.1,0,0,1,117.45,336.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,319.06l2.06,6.13a1.12,1.12,0,0,1-.7,1.4L93,335.75a1.11,1.11,0,0,1-1.4-.7l-2-6.13a.85.85,0,0,1,0-.35,1.08,1.08,0,0,1,.74-1.05l27.4-9.16a1.11,1.11,0,0,1,1.23.39A.76.76,0,0,1,119,319.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,319.06l2.06,6.13a1.12,1.12,0,0,1-.7,1.4L93,335.75a1.11,1.11,0,0,1-1.4-.7l-2-6.13a.85.85,0,0,1,0-.35,1.08,1.08,0,0,1,.74-1.05l27.4-9.16a1.11,1.11,0,0,1,1.23.39A.76.76,0,0,1,119,319.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.34,325.58,117.47,320a.37.37,0,0,0-.47-.24.38.38,0,0,0-.24.47l1.87,5.59-1.6.53-1.87-5.58a.37.37,0,0,0-.47-.24.38.38,0,0,0-.23.48l1.86,5.58-1.6.53-1.87-5.58a.37.37,0,0,0-.7.24l1.87,5.58-1.61.54-1.86-5.59a.37.37,0,0,0-.71.24l1.87,5.58-1.6.54-1.87-5.59a.37.37,0,0,0-.47-.23.38.38,0,0,0-.24.47l1.87,5.59-1.6.53-1.87-5.58a.37.37,0,0,0-.47-.24.36.36,0,0,0-.23.47l1.86,5.59-1.6.53-1.87-5.58a.37.37,0,1,0-.7.23l1.86,5.59-1.6.53-1.86-5.58a.37.37,0,0,0-.47-.23.36.36,0,0,0-.24.47l1.87,5.58-1.6.54L99,326.17a.37.37,0,0,0-.71.24l1.87,5.58-1.57.53h0l-1.87-5.58a.36.36,0,0,0-.47-.23.37.37,0,0,0-.24.47l1.77,5.26a1,1,0,0,1-.53-.64L95.85,328a1.1,1.1,0,0,0-1.4-.73l-3.86,1.29a1.14,1.14,0,0,0-.72,1.41L91.64,335a1.08,1.08,0,0,0,1.37.72l27.38-9.16a1.16,1.16,0,0,0,.72-1.43l0-.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.88,318.75l-29.37,9.82a1.08,1.08,0,0,1,.74-1.05l27.4-9.16A1.11,1.11,0,0,1,118.88,318.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,407.51V414a1.1,1.1,0,0,1-1.1,1.1H125.55a1.1,1.1,0,0,1-1.1-1.1v-6.47a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,155.53,407.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,407.51V414a1.1,1.1,0,0,1-1.1,1.1H125.55a1.1,1.1,0,0,1-1.1-1.1v-6.47a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,155.53,407.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,413.79V407.9a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89h-1.69V407.9a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.89h-1.69V407.9a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89H144V407.9a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.89h-1.68V407.9a.38.38,0,0,0-.75,0v5.89h-1.69V407.9a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.89h-1.68V407.9a.38.38,0,0,0-.75,0v5.55a1.11,1.11,0,0,1-.3-.77l-.09-4.07a1.1,1.1,0,0,0-1.1-1.13h-4.07a1.15,1.15,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,407.16h-31a1.08,1.08,0,0,1,1-.76h28.88A1.12,1.12,0,0,1,155.48,407.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,398.7v6.47a1.11,1.11,0,0,1-1.1,1.11H123.55a1.11,1.11,0,0,1-1.11-1.11V398.7a.93.93,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.76.76,0,0,1,153.53,398.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,398.7v6.47a1.11,1.11,0,0,1-1.1,1.11H123.55a1.11,1.11,0,0,1-1.11-1.11V398.7a.93.93,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.76.76,0,0,1,153.53,398.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.74,405V399.1a.37.37,0,1,0-.74,0V405h-1.69V399.1a.38.38,0,1,0-.75,0V405h-1.68V399.1a.38.38,0,1,0-.75,0V405h-1.69V399.1a.37.37,0,1,0-.74,0V405H142V399.1a.38.38,0,1,0-.75,0V405h-1.68V399.1a.38.38,0,1,0-.75,0V405h-1.69V399.1a.37.37,0,1,0-.74,0V405h-1.69V399.1a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38V405h-1.69V399.1a.38.38,0,1,0-.75,0V405h-1.69V399.1a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38v5.55a1.09,1.09,0,0,1-.3-.78l-.1-4.06a1.09,1.09,0,0,0-1.09-1.14h-4.07a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.12V405Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47,398.36h-31a1.09,1.09,0,0,1,1-.76h28.88A1.09,1.09,0,0,1,153.47,398.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,389.9v6.47a1.1,1.1,0,0,1-1.1,1.1H125.55a1.1,1.1,0,0,1-1.1-1.1V389.9a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,155.53,389.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,389.9v6.47a1.1,1.1,0,0,1-1.1,1.1H125.55a1.1,1.1,0,0,1-1.1-1.1V389.9a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,155.53,389.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,396.18v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89H144v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.88a.38.38,0,0,0-.75,0v5.55a1.11,1.11,0,0,1-.3-.77l-.09-4.07a1.1,1.1,0,0,0-1.1-1.13h-4.07a1.15,1.15,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,389.55h-31a1.08,1.08,0,0,1,1-.76h28.88A1.12,1.12,0,0,1,155.48,389.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,381.09v6.47a1.11,1.11,0,0,1-1.1,1.11H123.55a1.11,1.11,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.76.76,0,0,1,153.53,381.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,381.09v6.47a1.11,1.11,0,0,1-1.1,1.11H123.55a1.11,1.11,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.76.76,0,0,1,153.53,381.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.74,387.37v-5.88a.37.37,0,1,0-.74,0v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88H142v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88h-1.69v-5.88a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38V387a1.07,1.07,0,0,1-.3-.78l-.1-4.06a1.08,1.08,0,0,0-1.09-1.13h-4.07a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.13v-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47,380.75h-31a1.09,1.09,0,0,1,1-.76h28.88A1.09,1.09,0,0,1,153.47,380.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.54,372.29v6.47a1.11,1.11,0,0,1-1.11,1.1H128.55a1.1,1.1,0,0,1-1.1-1.1v-6.47a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,158.54,372.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.54,372.29v6.47a1.11,1.11,0,0,1-1.11,1.1H128.55a1.1,1.1,0,0,1-1.1-1.1v-6.47a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,158.54,372.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.75,378.57v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.74,0v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89H147v-5.89a.37.37,0,1,0-.74,0v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.74,0v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.88a.38.38,0,0,0-.75,0v5.55a1.11,1.11,0,0,1-.3-.77l-.09-4.06a1.11,1.11,0,0,0-1.1-1.14h-4.06a1.14,1.14,0,0,0-1.13,1.11l.06,5.38a1.08,1.08,0,0,0,1.08,1.11h28.86a1.16,1.16,0,0,0,1.14-1.12v-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.48,371.94h-31a1.08,1.08,0,0,1,1-.76h28.88A1.12,1.12,0,0,1,158.48,371.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,363.48V370a1.11,1.11,0,0,1-1.1,1.11H125.55a1.1,1.1,0,0,1-1.1-1.11v-6.47a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.93.93,0,0,1,155.53,363.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,363.48V370a1.11,1.11,0,0,1-1.1,1.11H125.55a1.1,1.1,0,0,1-1.1-1.11v-6.47a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.93.93,0,0,1,155.53,363.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,369.77v-5.89a.36.36,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.36.36,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89H144v-5.89a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.88a.38.38,0,0,0-.75,0v5.55a1.11,1.11,0,0,1-.3-.77l-.09-4.07a1.1,1.1,0,0,0-1.1-1.13h-4.07a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,363.14h-31a1.07,1.07,0,0,1,1-.76h28.88A1.11,1.11,0,0,1,155.48,363.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,354.68v6.47a1.1,1.1,0,0,1-1.1,1.1H125.55a1.1,1.1,0,0,1-1.1-1.1v-6.47a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.93.93,0,0,1,155.53,354.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,354.68v6.47a1.1,1.1,0,0,1-1.1,1.1H125.55a1.1,1.1,0,0,1-1.1-1.1v-6.47a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.93.93,0,0,1,155.53,354.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,361v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37V361h-1.69v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37V361h-1.69v-5.89a.38.38,0,0,0-.75,0V361h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37V361H144v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37V361h-1.69v-5.89a.38.38,0,0,0-.75,0V361h-1.68v-5.89a.38.38,0,0,0-.75,0V361h-1.69v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37V361h-1.69v-5.89a.38.38,0,0,0-.75,0V361h-1.68v-5.88a.38.38,0,0,0-.75,0v5.56a1.13,1.13,0,0,1-.3-.78l-.09-4.06a1.11,1.11,0,0,0-1.1-1.14h-4.07a1.15,1.15,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.12V361Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,354.34h-31a1.07,1.07,0,0,1,1-.76h28.88A1.11,1.11,0,0,1,155.48,354.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,345.87v6.48a1.1,1.1,0,0,1-1.1,1.1H123.55a1.11,1.11,0,0,1-1.11-1.1v-6.48a1,1,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.82.82,0,0,1,153.53,345.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,345.87v6.48a1.1,1.1,0,0,1-1.1,1.1H123.55a1.11,1.11,0,0,1-1.11-1.1v-6.48a1,1,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.82.82,0,0,1,153.53,345.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.74,352.16v-5.89a.37.37,0,0,0-.74,0v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.74,0v5.89H142v-5.89a.38.38,0,0,0-.75,0v5.89h-1.68v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,1,0-.74,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.36.36,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.88a.36.36,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.55a1.06,1.06,0,0,1-.3-.77l-.1-4.07a1.09,1.09,0,0,0-1.09-1.13h-4.07a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47,345.53h-31a1.09,1.09,0,0,1,1-.76h28.88A1.09,1.09,0,0,1,153.47,345.53Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,337.07v6.47a1.11,1.11,0,0,1-1.1,1.11H123.55a1.11,1.11,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.76.76,0,0,1,153.53,337.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,337.07v6.47a1.11,1.11,0,0,1-1.1,1.11H123.55a1.11,1.11,0,0,1-1.11-1.11v-6.47a.93.93,0,0,1,.06-.34,1.09,1.09,0,0,1,1-.76h28.88a1.09,1.09,0,0,1,1,.76A.76.76,0,0,1,153.53,337.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.74,343.35v-5.88a.37.37,0,1,0-.74,0v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88H142v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,1,0-.74,0v5.88h-1.69v-5.88a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38V343a1.09,1.09,0,0,1-.3-.78l-.1-4.06a1.09,1.09,0,0,0-1.09-1.14h-4.07a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.12v-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47,336.73h-31a1.09,1.09,0,0,1,1-.76h28.88A1.09,1.09,0,0,1,153.47,336.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,328.27v6.47a1.11,1.11,0,0,1-1.1,1.1H119.55a1.1,1.1,0,0,1-1.11-1.1v-6.47a1,1,0,0,1,.06-.35,1.09,1.09,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.83.83,0,0,1,149.53,328.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,328.27v6.47a1.11,1.11,0,0,1-1.1,1.1H119.55a1.1,1.1,0,0,1-1.11-1.1v-6.47a1,1,0,0,1,.06-.35,1.09,1.09,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.83.83,0,0,1,149.53,328.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.74,334.55v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89H138v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89h-1.69v-5.88a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.55a1.06,1.06,0,0,1-.3-.77l-.1-4.07a1.09,1.09,0,0,0-1.1-1.13h-4.06a1.14,1.14,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.16,1.16,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,327.92h-31a1.09,1.09,0,0,1,1-.76h28.88A1.11,1.11,0,0,1,149.47,327.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,319.46v6.47a1.11,1.11,0,0,1-1.1,1.11H125.55a1.11,1.11,0,0,1-1.1-1.11v-6.47a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.93.93,0,0,1,155.53,319.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,319.46v6.47a1.11,1.11,0,0,1-1.1,1.11H125.55a1.11,1.11,0,0,1-1.1-1.11v-6.47a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1,.76A.93.93,0,0,1,155.53,319.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,325.74v-5.88a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38v5.88h-1.69v-5.88a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38v5.88H144v-5.88a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.88h-1.69v-5.88a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38v5.88h-1.69v-5.88a.38.38,0,1,0-.75,0v5.88h-1.68v-5.88a.38.38,0,1,0-.75,0v5.55a1.11,1.11,0,0,1-.3-.78l-.09-4.06a1.11,1.11,0,0,0-1.1-1.14h-4.07a1.15,1.15,0,0,0-1.13,1.11l.07,5.38a1.07,1.07,0,0,0,1.07,1.11h28.87a1.15,1.15,0,0,0,1.13-1.12v-.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,319.12h-31a1.07,1.07,0,0,1,1-.76h28.88A1.11,1.11,0,0,1,155.48,319.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.56,407.51V414a1.11,1.11,0,0,1-1.1,1.1H165.57a1.1,1.1,0,0,1-1.1-1.1v-6.47a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.89a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,195.56,407.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.56,407.51V414a1.11,1.11,0,0,1-1.1,1.1H165.57a1.1,1.1,0,0,1-1.1-1.1v-6.47a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.89a1.12,1.12,0,0,1,1,.76A1,1,0,0,1,195.56,407.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.77,413.79V407.9a.38.38,0,0,0-.75,0v5.89h-1.68V407.9a.38.38,0,0,0-.75,0v5.89H188.9V407.9a.37.37,0,0,0-.74,0v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.89H184V407.9a.38.38,0,0,0-.75,0v5.89H181.6V407.9a.37.37,0,1,0-.74,0v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.89h-1.68V407.9a.38.38,0,0,0-.75,0v5.89H174.3V407.9a.37.37,0,0,0-.74,0v5.89h-1.69V407.9a.38.38,0,0,0-.75,0v5.55a1.06,1.06,0,0,1-.29-.77l-.1-4.07a1.1,1.1,0,0,0-1.1-1.13h-4.06a1.14,1.14,0,0,0-1.13,1.11l.06,5.38a1.08,1.08,0,0,0,1.08,1.11h28.87a1.16,1.16,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.5,407.16h-31a1.08,1.08,0,0,1,1-.76h28.89A1.12,1.12,0,0,1,195.5,407.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,398.7v6.47a1.12,1.12,0,0,1-1.11,1.11H163.57a1.11,1.11,0,0,1-1.1-1.11V398.7a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1.05.76A.93.93,0,0,1,193.56,398.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,398.7v6.47a1.12,1.12,0,0,1-1.11,1.11H163.57a1.11,1.11,0,0,1-1.1-1.11V398.7a.76.76,0,0,1,.06-.34,1.07,1.07,0,0,1,1-.76h28.88a1.11,1.11,0,0,1,1.05.76A.93.93,0,0,1,193.56,398.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.77,405V399.1a.38.38,0,1,0-.75,0V405h-1.69V399.1a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38V405H186.9V399.1a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38V405h-1.69V399.1a.38.38,0,1,0-.75,0V405H182V399.1a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38V405H179.6V399.1a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38V405h-1.69V399.1a.38.38,0,1,0-.75,0V405h-1.69V399.1a.37.37,0,0,0-.37-.38.38.38,0,0,0-.37.38V405H172.3V399.1a.38.38,0,0,0-.37-.38.37.37,0,0,0-.37.38V405h-1.69V399.1a.38.38,0,1,0-.75,0v5.55a1.08,1.08,0,0,1-.29-.78l-.1-4.06a1.11,1.11,0,0,0-1.1-1.14h-4.06a1.14,1.14,0,0,0-1.13,1.11l.06,5.38a1.08,1.08,0,0,0,1.08,1.11h28.87a1.15,1.15,0,0,0,1.13-1.12V405Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,398.36h-31a1.07,1.07,0,0,1,1-.76h28.88A1.11,1.11,0,0,1,193.5,398.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,389.9v6.47a1.11,1.11,0,0,1-1.11,1.1H163.57a1.1,1.1,0,0,1-1.1-1.1V389.9a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1.05.76A1,1,0,0,1,193.56,389.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,389.9v6.47a1.11,1.11,0,0,1-1.11,1.1H163.57a1.1,1.1,0,0,1-1.1-1.1V389.9a.83.83,0,0,1,.06-.35,1.08,1.08,0,0,1,1-.76h28.88a1.12,1.12,0,0,1,1.05.76A1,1,0,0,1,193.56,389.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.77,396.18v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89H186.9v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89H182v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89H179.6v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.89a.38.38,0,0,0-.75,0v5.89h-1.69v-5.89a.37.37,0,0,0-.37-.37.38.38,0,0,0-.37.37v5.89H172.3v-5.89a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v5.89h-1.69v-5.88a.38.38,0,0,0-.75,0v5.55a1.06,1.06,0,0,1-.29-.77l-.1-4.07a1.1,1.1,0,0,0-1.1-1.13h-4.06a1.14,1.14,0,0,0-1.13,1.11l.06,5.38a1.08,1.08,0,0,0,1.08,1.11h28.87a1.16,1.16,0,0,0,1.13-1.13v-.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,389.55h-31a1.08,1.08,0,0,1,1-.76h28.88A1.12,1.12,0,0,1,193.5,389.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.92,
    cy: 399.56,
    r: 15.52,
    transform: "translate(-57.74 22.57) rotate(-8.51)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.92,
    cy: 399.56,
    r: 15.52,
    transform: "translate(-57.74 22.57) rotate(-8.51)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.44,403.94c.58-.78.15-1.67-.61-2.66l-2.1,2.84C122,404.81,122.93,404.63,123.44,403.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61,395.44c-.57.77-.14,1.63.59,2.59l2.11-2.86C124,394.51,123.13,394.73,122.61,395.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57,407.44A13.25,13.25,0,1,0,115,410.21,13.24,13.24,0,0,0,133.57,407.44Zm-16.78-.75,1.32-1.78a8.69,8.69,0,0,1-3-4.24l1.92-1.08a7.62,7.62,0,0,0,2.31,3.59l2.37-3.21c-1.46-1.75-2.94-3.74-1.29-6,1.21-1.64,3.45-2.18,6.13-.57l1.34-1.82,1.32,1-1.32,1.78a8.47,8.47,0,0,1,2.53,3.39l-1.85,1.13a8.23,8.23,0,0,0-2-2.79l-2.4,3.24c1.46,1.75,3,3.75,1.34,6-1.21,1.63-3.46,2.16-6.17.55l-1.33,1.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.37,
    y: 165.51,
    width: 1,
    height: 128.55,
    transform: "translate(-0.24 0.23) rotate(-0.06)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,180.73h0l-94.79-8L218.77,166a.5.5,0,0,1-.19-.94l89.75-45.89a.5.5,0,0,1,.49,0l98.53,60.6a.48.48,0,0,1,.21.58A.49.49,0,0,1,407.09,180.73ZM220.63,165.14l91.71,6.58,92.7,7.83-96.5-59.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.88 329.88 393.02 329.43 246.8 251.56 246.73 251.38 218.33 165.67 219.28 165.36 247.62 250.87 392.63 328.08 379.37 229.91 311.82 172.47 311.8 172.26 308.06 119.67 309.06 119.59 312.78 171.97 380.31 229.39 380.33 229.58 393.88 329.88",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,329.47,218.84,294.55a.5.5,0,0,1-.32-.76l28.27-42.85a.57.57,0,0,1,.34-.22l132.38-21.53L406.65,180l.88.49-27.26,49.42a.48.48,0,0,1-.36.25L247.5,251.68l-27.74,42,173.59,34.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.27,
    y: 211.09,
    width: 102.76,
    height: 1,
    transform: "translate(-61.54 292.59) rotate(-50.47)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.37,
    y: 165.51,
    width: 1,
    height: 128.55,
    transform: "translate(-0.24 0.23) rotate(-0.06)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,180.73h0l-94.79-8L218.77,166a.5.5,0,0,1-.19-.94l89.75-45.89a.5.5,0,0,1,.49,0l98.53,60.6a.48.48,0,0,1,.21.58A.49.49,0,0,1,407.09,180.73ZM220.63,165.14l91.71,6.58,92.7,7.83-96.5-59.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.88 329.88 393.02 329.43 246.8 251.56 246.73 251.38 218.33 165.67 219.28 165.36 247.62 250.87 392.63 328.08 379.37 229.91 311.82 172.47 311.8 172.26 308.06 119.67 309.06 119.59 312.78 171.97 380.31 229.39 380.33 229.58 393.88 329.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,329.47,218.84,294.55a.5.5,0,0,1-.32-.76l28.27-42.85a.57.57,0,0,1,.34-.22l132.38-21.53L406.65,180l.88.49-27.26,49.42a.48.48,0,0,1-.36.25L247.5,251.68l-27.74,42,173.59,34.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.27,
    y: 211.09,
    width: 102.76,
    height: 1,
    transform: "translate(-61.54 292.59) rotate(-50.47)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.9,251.22a2,2,0,1,1-2-2A2,2,0,0,1,248.9,251.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.35,
    cy: 171.96,
    r: 1.96,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.55,
    cy: 229.86,
    r: 1.96,
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elements--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "405.44 318.79 405.44 348.87 377.07 348.87 377.07 312.1 398.76 312.1 405.44 318.79",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.44 315.79 409.44 345.87 381.07 345.87 381.07 309.1 402.76 309.1 409.44 315.79",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.44 315.79 409.44 345.87 381.07 345.87 381.07 309.1 402.76 309.1 409.44 315.79",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.44 315.79 402.76 315.79 402.76 309.1 409.44 315.79",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.44 315.79 402.76 315.79 402.76 309.1 409.44 315.79",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 386.88,
    y: 318.05,
    width: 16.75,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 386.88,
    y: 322.52,
    width: 16.75,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 386.88,
    y: 326.98,
    width: 16.75,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 386.88,
    y: 331.45,
    width: 16.75,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 386.88,
    y: 335.92,
    width: 12.75,
    height: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 388.21,
    y: 165.4,
    width: 37.76,
    height: 29.66,
    rx: 5.62,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.87 173.92 398.87 186.53 415.31 180.22 398.87 173.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.06,
    y: 103.13,
    width: 32.99,
    height: 32.99,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.06,
    y: 103.13,
    width: 32.99,
    height: 32.99,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,112.81l-3.9-2-1.51-.8V124.8a4.38,4.38,0,0,0-1.93-.42c-1.9,0-3.44,1.1-3.44,2.46s1.54,2.46,3.44,2.46,3.44-1.1,3.45-2.46h0V114.9l3.9,1.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 147.8,
    width: 45.1,
    height: 35.42,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 147.8,
    width: 45.1,
    height: 35.42,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.09,
    y: 145.96,
    width: 29.42,
    height: 39.1,
    transform: "translate(384.32 -53.29) rotate(90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.25 174.42 210.89 166.4 216.96 171.93 230.93 161.78 238.35 168.1 238.35 180.22 199.25 180.22 199.25 174.42",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.13,159.34a3.76,3.76,0,1,1-3.76-3.76A3.76,3.76,0,0,1,213.13,159.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.1,
    y: 274.61,
    width: 36.9,
    height: 36.9,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.1,
    y: 274.61,
    width: 36.9,
    height: 36.9,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.47,
    y: 271.97,
    width: 18.15,
    height: 30.07,
    transform: "translate(505.55 68.46) rotate(90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.51 293.85 212.46 287.68 217.13 291.94 227.87 284.13 233.58 288.99 233.58 296.08 203.51 296.08 203.51 293.85",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.18,282.25a2.89,2.89,0,1,1-2.89-2.89A2.89,2.89,0,0,1,214.18,282.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,304.11h1.49v3.38a5.41,5.41,0,0,1-3.32,1.08,4.37,4.37,0,1,1,0-8.73,4.42,4.42,0,0,1,3.41,1.38l-1,1a3.16,3.16,0,0,0-2.34-1,3,3,0,1,0,0,6,3.5,3.5,0,0,0,1.75-.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.64,300h1.57v8.49h-1.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,301.29v2.58h4.1v1.33h-4.1v3.25H222.5V300h6.19v1.33Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Platform--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.38,225h0a1.44,1.44,0,0,1-1.44-1.44V155.47a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v68.07A1.43,1.43,0,0,1,282.38,225Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.38,329.72h0a1.45,1.45,0,0,1-1.44-1.44V260.21a1.44,1.44,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v68.07A1.44,1.44,0,0,1,282.38,329.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,206.11h0a1.45,1.45,0,0,1-1.44-1.44V136.6a1.44,1.44,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v68.07A1.44,1.44,0,0,1,305.76,206.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.88,243.93h0a1.43,1.43,0,0,1-1.44-1.44V174.42a1.44,1.44,0,0,1,1.44-1.44h0a1.45,1.45,0,0,1,1.44,1.44v68.07A1.44,1.44,0,0,1,329.88,243.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,383.22h0a1.44,1.44,0,0,1-1.44-1.44V313.71a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v68.07A1.43,1.43,0,0,1,346.8,383.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,289.4h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,346.8,289.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.44,317.73h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,326.44,317.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,261.13h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,305.76,261.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,192.3h0a1.43,1.43,0,0,1-1.44-1.44v-8a1.43,1.43,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v8A1.43,1.43,0,0,1,268.33,192.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,295.43h0a1.44,1.44,0,0,1-1.44-1.44v-8a1.44,1.44,0,0,1,1.44-1.44h0A1.43,1.43,0,0,1,307.2,286v8A1.43,1.43,0,0,1,305.76,295.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,372.6h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,325,372.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,222.45h0a1.44,1.44,0,0,1-1.44-1.44V152.94a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44V221A1.43,1.43,0,0,1,346.8,222.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,388.56h0a1.43,1.43,0,0,1-1.44-1.44V319.06a1.43,1.43,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v68.06A1.43,1.43,0,0,1,268.33,388.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,402.61h0a1.44,1.44,0,0,1-1.44-1.44V333.1a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v68.07A1.43,1.43,0,0,1,305.76,402.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.38,225h0a1.44,1.44,0,0,1-1.44-1.44V155.47a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v68.07A1.43,1.43,0,0,1,282.38,225Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.38,329.72h0a1.45,1.45,0,0,1-1.44-1.44V260.21a1.44,1.44,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v68.07A1.44,1.44,0,0,1,282.38,329.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,206.11h0a1.45,1.45,0,0,1-1.44-1.44V136.6a1.44,1.44,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v68.07A1.44,1.44,0,0,1,305.76,206.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.88,243.93h0a1.43,1.43,0,0,1-1.44-1.44V174.42a1.44,1.44,0,0,1,1.44-1.44h0a1.45,1.45,0,0,1,1.44,1.44v68.07A1.44,1.44,0,0,1,329.88,243.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,383.22h0a1.44,1.44,0,0,1-1.44-1.44V313.71a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v68.07A1.43,1.43,0,0,1,346.8,383.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,289.4h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,346.8,289.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.44,317.73h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,326.44,317.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,261.13h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,305.76,261.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,192.3h0a1.43,1.43,0,0,1-1.44-1.44v-8a1.43,1.43,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v8A1.43,1.43,0,0,1,268.33,192.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,295.43h0a1.44,1.44,0,0,1-1.44-1.44v-8a1.44,1.44,0,0,1,1.44-1.44h0A1.43,1.43,0,0,1,307.2,286v8A1.43,1.43,0,0,1,305.76,295.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,372.6h0a1.45,1.45,0,0,1-1.44-1.44v-8a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v8A1.44,1.44,0,0,1,325,372.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,222.45h0a1.44,1.44,0,0,1-1.44-1.44V152.94a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44V221A1.43,1.43,0,0,1,346.8,222.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,388.56h0a1.43,1.43,0,0,1-1.44-1.44V319.06a1.43,1.43,0,0,1,1.44-1.44h0a1.43,1.43,0,0,1,1.44,1.44v68.06A1.43,1.43,0,0,1,268.33,388.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,402.61h0a1.44,1.44,0,0,1-1.44-1.44V333.1a1.45,1.45,0,0,1,1.44-1.44h0a1.44,1.44,0,0,1,1.44,1.44v68.07A1.43,1.43,0,0,1,305.76,402.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,400.25H250.67A2.16,2.16,0,0,0,249,401l-3.21,3.63a2.17,2.17,0,0,0-.14,2.7H369.45a2.2,2.2,0,0,0-.14-2.7L366.09,401A2.15,2.15,0,0,0,364.47,400.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,400.25H250.67A2.16,2.16,0,0,0,249,401l-3.21,3.63a2.17,2.17,0,0,0-.14,2.7H369.45a2.2,2.2,0,0,0-.14-2.7L366.09,401A2.15,2.15,0,0,0,364.47,400.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.61 395.91 253.52 395.91 251.44 397.73 251.44 404.6 363.69 404.6 363.69 397.73 361.61 395.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.61 395.91 253.52 395.91 251.44 397.73 251.44 404.6 363.69 404.6 363.69 397.73 361.61 395.91",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.73 404.6 251.41 404.6 237.9 410.9 237.9 414.46 377.23 414.46 377.23 410.9 363.73 404.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.73 404.6 251.41 404.6 237.9 410.9 377.23 410.9 363.73 404.6",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.61 395.91 253.52 395.91 251.44 397.73 363.69 397.73 361.61 395.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,407.32h0a1.69,1.69,0,0,1-1.69-1.68v-3.71a1.69,1.69,0,0,1,1.69-1.68h0a1.69,1.69,0,0,1,1.68,1.68v3.71A1.68,1.68,0,0,1,307.57,407.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,407.32h0a1.69,1.69,0,0,1-1.69-1.68v-3.71a1.69,1.69,0,0,1,1.69-1.68h0a1.69,1.69,0,0,1,1.68,1.68v3.71A1.68,1.68,0,0,1,307.57,407.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--NFT--inject-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.55,
    cy: 236.53,
    rx: 45.32,
    ry: 49.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.86,236.1v.43c0,.24,0,.46,0,.7,0,.92,0,1.84-.1,2.75,0,.38,0,.76-.09,1.14q-.11,1.4-.3,2.76c0,.39-.1.76-.15,1.14-.15.92-.32,1.84-.52,2.75-.08.37-.16.75-.25,1.13-.22.94-.46,1.86-.72,2.77l-.36,1.13c-.29.93-.61,1.85-.95,2.75-.15.39-.3.76-.46,1.14-.38.94-.78,1.86-1.21,2.76-.18.39-.38.76-.57,1.14-.48.94-1,1.85-1.5,2.75-.23.38-.45.76-.69,1.13-.59.95-1.22,1.87-1.87,2.77-.27.38-.55.76-.85,1.13q-1.1,1.44-2.28,2.76c-.34.39-.7.76-1.05,1.14-.91,1-1.86,1.88-2.85,2.75-.43.39-.88.77-1.33,1.14a41.75,41.75,0,0,1-3.73,2.76c-.59.4-1.19.77-1.8,1.13a42.15,42.15,0,0,1-5.45,2.75c-1,.43-2,.8-3,1.14a41.81,41.81,0,0,1-26.41,0c-1-.34-2-.71-3-1.14-17-7.13-29.09-25.16-29.09-46.27s12-39,28.95-46.22c.79-.33,1.6-.65,2.42-.93a41.77,41.77,0,0,1,27.91,0c1,.34,1.94.72,2.89,1.13a45.32,45.32,0,0,1,5.26,2.75c.6.37,1.18.74,1.76,1.14a42.23,42.23,0,0,1,3.66,2.76c.44.37.87.75,1.3,1.14,1,.87,1.91,1.78,2.81,2.75q.52.55,1,1.14a35.16,35.16,0,0,1,2.25,2.76c.3.37.58.75.86,1.13.63.9,1.25,1.82,1.83,2.76.24.38.46.75.68,1.14.52.9,1,1.81,1.49,2.75.18.38.37.75.55,1.14q.63,1.35,1.2,2.76c.16.37.3.75.44,1.14.34.89.66,1.81.94,2.75.13.37.24.76.34,1.13.27.91.5,1.83.72,2.76.09.38.17.77.25,1.14.18.91.35,1.83.49,2.75.06.38.11.75.16,1.14.12.91.23,1.83.28,2.76a10.55,10.55,0,0,1,.08,1.14C356.83,234.24,356.85,235.16,356.86,236.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.86,236.1v.43c0,.24,0,.46,0,.7,0,.92,0,1.84-.1,2.75,0,.38,0,.76-.09,1.14q-.11,1.4-.3,2.76c0,.39-.1.76-.15,1.14-.15.92-.32,1.84-.52,2.75-.08.37-.16.75-.25,1.13-.22.94-.46,1.86-.72,2.77l-.36,1.13c-.29.93-.61,1.85-.95,2.75-.15.39-.3.76-.46,1.14-.38.94-.78,1.86-1.21,2.76-.18.39-.38.76-.57,1.14-.48.94-1,1.85-1.5,2.75-.23.38-.45.76-.69,1.13-.59.95-1.22,1.87-1.87,2.77-.27.38-.55.76-.85,1.13q-1.1,1.44-2.28,2.76c-.34.39-.7.76-1.05,1.14-.91,1-1.86,1.88-2.85,2.75-.43.39-.88.77-1.33,1.14a41.75,41.75,0,0,1-3.73,2.76c-.59.4-1.19.77-1.8,1.13a42.15,42.15,0,0,1-5.45,2.75c-1,.43-2,.8-3,1.14a41.81,41.81,0,0,1-26.41,0c-1-.34-2-.71-3-1.14-17-7.13-29.09-25.16-29.09-46.27s12-39,28.95-46.22c.79-.33,1.6-.65,2.42-.93a41.77,41.77,0,0,1,27.91,0c1,.34,1.94.72,2.89,1.13a45.32,45.32,0,0,1,5.26,2.75c.6.37,1.18.74,1.76,1.14a42.23,42.23,0,0,1,3.66,2.76c.44.37.87.75,1.3,1.14,1,.87,1.91,1.78,2.81,2.75q.52.55,1,1.14a35.16,35.16,0,0,1,2.25,2.76c.3.37.58.75.86,1.13.63.9,1.25,1.82,1.83,2.76.24.38.46.75.68,1.14.52.9,1,1.81,1.49,2.75.18.38.37.75.55,1.14q.63,1.35,1.2,2.76c.16.37.3.75.44,1.14.34.89.66,1.81.94,2.75.13.37.24.76.34,1.13.27.91.5,1.83.72,2.76.09.38.17.77.25,1.14.18.91.35,1.83.49,2.75.06.38.11.75.16,1.14.12.91.23,1.83.28,2.76a10.55,10.55,0,0,1,.08,1.14C356.83,234.24,356.85,235.16,356.86,236.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.77,282.8c-1,.43-2,.8-3,1.14H295.17V282.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335,278.92c-.59.4-1.19.77-1.8,1.13H295.17v-1.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M340.08,275c-.43.39-.88.77-1.33,1.14H295.17V275Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M344,271.13c-.34.39-.7.76-1.05,1.14H295.17v-1.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.11,267.24c-.27.38-.55.76-.85,1.13H295.17v-1.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M349.67,263.34c-.23.38-.45.76-.69,1.13H295.17v-1.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.74,259.45c-.18.39-.38.76-.57,1.14h-56v-1.14Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M353.41,255.55c-.15.39-.3.76-.46,1.14H295.17v-1.14Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M354.72,251.67l-.36,1.13H295.17v-1.13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M355.69,247.77c-.08.37-.16.75-.25,1.13H295.17v-1.13Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M356.36,243.88c0,.39-.1.76-.15,1.14h-61v-1.14Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M356.75,240c0,.38,0,.76-.09,1.14H295.17V240Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M356.86,236.1v.43c0,.24,0,.46,0,.7H295.17V236.1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M356.76,233.34H295.17V232.2h61.51A10.55,10.55,0,0,1,356.76,233.34Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M356.4,229.44H295.17V228.3h61.07C356.3,228.68,356.35,229.05,356.4,229.44Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M355.75,225.55H295.17v-1.14H355.5C355.59,224.79,355.67,225.18,355.75,225.55Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M354.78,221.65H295.17v-1.13h59.27C354.57,220.89,354.68,221.28,354.78,221.65Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M353.5,217.77H295.17v-1.14h57.89C353.22,217,353.36,217.38,353.5,217.77Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M351.86,213.87H295.17v-1.14h56.14C351.49,213.11,351.68,213.48,351.86,213.87Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M349.82,210H295.17v-1.14h54C349.38,209.22,349.6,209.59,349.82,210Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M347.31,206.08H295.17V205h51.28C346.75,205.32,347,205.7,347.31,206.08Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M344.2,202.19h-49v-1.14h48Q343.7,201.6,344.2,202.19Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M340.37,198.3h-45.2v-1.14h43.9C339.51,197.53,339.94,197.91,340.37,198.3Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M335.41,194.4H295.17v-1.14h38.48C334.25,193.63,334.83,194,335.41,194.4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M328.39,190.51H295.17v-1.13H325.5C326.48,189.72,327.44,190.1,328.39,190.51Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.59,
    cy: 236.53,
    rx: 45.32,
    ry: 49.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.59,
    cy: 236.53,
    rx: 45.32,
    ry: 49.55,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.59,
    cy: 236.53,
    rx: 40.39,
    ry: 44.16,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M304.16,280.68h-.57c-22.31,0-40.39-19.77-40.39-44.16s18.08-44.16,40.39-44.16h.57c-22.05.33-39.83,20-39.83,44.15S282.11,280.35,304.16,280.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M294.43,223.34V246H290.5l-10.31-13.73V246h-4.73V223.34h4l10.29,13.73V223.34Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304.12,227.54v6h9.57v4.2h-9.57V246h-4.79V223.34H315v4.2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M322.64,227.61H316v-4.27h18v4.27h-6.62V246h-4.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M293.3,223.34V246h-3.93l-10.32-13.73V246h-4.73V223.34h4l10.29,13.73V223.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,227.54v6h9.58v4.2H303V246H298.2V223.34h15.63v4.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,227.61h-6.61v-4.27h18v4.27h-6.62V246H321.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.3,223.34V246h-3.93l-10.32-13.73V246h-4.73V223.34h4l10.29,13.73V223.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,227.54v6h9.58v4.2H303V246H298.2V223.34h15.63v4.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,227.61h-6.61v-4.27h18v4.27h-6.62V246H321.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.45,187.26l-41.09,79a52.32,52.32,0,0,1-9.09-29.77c0-27.37,20.29-49.55,45.32-49.55A41.18,41.18,0,0,1,308.45,187.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,190.63l-44.42,85.42a45.33,45.33,0,0,1-6.6-6.68l42.39-81.53A42.23,42.23,0,0,1,320.68,190.63Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.67,195.26,284,281.21c-.77-.41-1.53-.83-2.26-1.28l44.79-86.15C327.25,194.24,328,194.74,328.67,195.26Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.12 191.59 280.45 185.39 278.78 191.59 272.58 193.26 278.78 194.93 280.45 201.14 282.12 194.93 288.33 193.26 282.12 191.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.76 256.62 336.41 251.61 335.06 256.62 330.05 257.97 335.06 259.32 336.41 264.33 337.76 259.32 342.77 257.97 337.76 256.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.36 184.23 294.6 187.08 291.75 187.84 294.6 188.61 295.36 191.46 296.13 188.61 298.98 187.84 296.13 187.08 295.36 184.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.94 209.12 291.17 211.97 288.33 212.73 291.17 213.5 291.94 216.34 292.71 213.5 295.55 212.73 292.71 211.97 291.94 209.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.05 275.31 329.28 278.15 326.44 278.92 329.28 279.68 330.05 282.53 330.81 279.68 333.66 278.92 330.81 278.15 330.05 275.31",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.73,114.73h-28a9.63,9.63,0,0,0-9.63,9.63v27.23a9.63,9.63,0,0,0,9.63,9.63h19.15l6.51,8.39,0-8.39h2.39a9.64,9.64,0,0,0,9.63-9.63V124.36A9.63,9.63,0,0,0,141.73,114.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.72,122.65l-15.62,6.29s.22,20.18,15.62,24.73c15.4-4.55,15.62-24.73,15.62-24.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.72,124.84l-13.42,5.4s.18,17.34,13.42,21.25c13.23-3.91,13.42-21.25,13.42-21.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.72,124.84l-13.42,5.4s.18,17.34,13.42,21.25c13.23-3.91,13.42-21.25,13.42-21.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.49,143.87a1.5,1.5,0,0,1-1.06-.44L120,138a1.5,1.5,0,0,1,2.13-2.12l4.34,4.34,6.83-7.29a1.5,1.5,0,1,1,2.19,2l-7.89,8.42a1.51,1.51,0,0,1-1.07.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.22,283.38s19.77-8.87,46.12-4.92c0,0-4.55-53.12-6.21-60.25s-39.49,1.23-39.49,1.23,2.45,21.16,2.06,34.23S140.56,281.15,142.22,283.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22,283.38s19.77-8.87,46.12-4.92c0,0-4.55-53.12-6.21-60.25s-39.49,1.23-39.49,1.23,2.45,21.16,2.06,34.23S140.56,281.15,142.22,283.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.94 409.93 192.11 411.86 190.48 401.23 189.61 395.55 196.44 393.62 197.6 401.23 198.94 409.93",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.67 410.49 152.63 411.42 152.56 401.23 152.51 394.9 159.57 393.98 159.61 401.23 159.67 410.49",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.57 393.98 159.61 401.23 152.56 401.23 152.51 394.9 159.57 393.98",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.6 401.23 190.48 401.23 189.61 395.55 196.44 393.62 197.6 401.23",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.85,408.86l-7.75-.21a.63.63,0,0,0-.62.47l-1.63,6.25a1,1,0,0,0,1,1.28c2.8,0,6.85,0,10.37.07,4.11.11,6.72-.09,11.55,0,2.91.08,3.83-2.83,2.62-3.13-5.52-1.36-9.12-1.09-13.81-4.17A3.39,3.39,0,0,0,198.85,408.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41,409.72a.16.16,0,0,1,.1-.17c.33-.16,3.23-1.53,4.08-1a.55.55,0,0,1,.26.46.93.93,0,0,1-.35.8c-.8.67-2.82.33-4,.08h0A.18.18,0,0,1,199.41,409.72Zm.7-.08c1.56.3,2.73.27,3.18-.11a.6.6,0,0,0,.22-.53.18.18,0,0,0-.1-.18l-.06,0C202.82,408.59,201.26,409.14,200.11,409.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,409.84a.17.17,0,0,1-.07-.16,4.79,4.79,0,0,1,1.2-2.69,1.22,1.22,0,0,1,.95-.26c.46.06.58.29.61.48.1.8-1.66,2.29-2.53,2.65h-.12Zm2-2.78a.92.92,0,0,0-.69.19,4,4,0,0,0-1,2.16c.89-.5,2.09-1.67,2-2.15,0,0,0-.11-.15-.16A.61.61,0,0,0,201.51,407.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.39,408.86l-7.76-.21a.64.64,0,0,0-.62.47l-1.63,6.25a1,1,0,0,0,1,1.28c2.8,0,6.85,0,10.36.07,4.12.11,6.73-.09,11.55,0,2.92.08,3.83-2.83,2.62-3.13-5.51-1.36-9.11-1.09-13.81-4.17A3.35,3.35,0,0,0,159.39,408.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,409.72a.17.17,0,0,1,.09-.17c.33-.16,3.24-1.53,4.08-1a.54.54,0,0,1,.27.46,1,1,0,0,1-.35.8c-.8.67-2.83.33-4,.08h0A.17.17,0,0,1,160,409.72Zm.7-.08c1.55.3,2.73.27,3.18-.11a.6.6,0,0,0,.22-.53.18.18,0,0,0-.1-.18l-.06,0C163.36,408.59,161.79,409.14,160.65,409.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,409.84a.17.17,0,0,1-.06-.16,4.79,4.79,0,0,1,1.2-2.69,1.2,1.2,0,0,1,.94-.26c.46.06.59.29.61.48.1.8-1.65,2.29-2.52,2.65h-.13Zm2-2.78a.94.94,0,0,0-.7.19,4,4,0,0,0-1,2.16c.89-.5,2.09-1.67,2-2.15a.21.21,0,0,0-.15-.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.15,255.67c-3.73,16.18,2.67,143.39,2.67,143.39h12.37l5.29-106,19.48,106,13.22-1C189.54,316,181.9,266.94,181.9,266.94l0-6.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.15,255.67c-3.73,16.18,2.67,143.39,2.67,143.39h12.37l5.29-106,19.48,106,13.22-1C189.54,316,181.9,266.94,181.9,266.94l0-6.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.63,315.6l-4.15-22.55.8-11.94S172,301.81,169.63,315.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.38 261.34 155.4 261.34 155.4 264.04 143.98 264.01 144.38 261.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.41 261.34 175.77 261.34 175.77 264.09 156.41 264.04 156.41 261.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.36 261.34 182.36 264.11 176.77 264.1 176.77 261.34 182.36 261.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,264.33h-2.87a.92.92,0,0,1-.92-.92V262a.92.92,0,0,1,.92-.92h2.87a.92.92,0,0,1,.91.92v1.4A.92.92,0,0,1,168.1,264.33Zm-2.87-2.74a.42.42,0,0,0-.42.42v1.4a.42.42,0,0,0,.42.42h2.87a.41.41,0,0,0,.41-.42V262a.41.41,0,0,0-.41-.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.12,263H167a.25.25,0,1,1,0-.5h1.14a.25.25,0,0,1,0,.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.08,206.1c7,.31,18.58,26.21,18.58,26.21l-5,7.48-14-18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.71,221.8l.29.38,11.7,15,2,2.58,5-7.49s-11.6-25.89-18.58-26.21Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,222.18l11.7,15c0-.27-.1-.57-.17-.89-2.86-12.42-10.95-17.9-10.95-17.9A12.56,12.56,0,0,0,181,222.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29,206a126.45,126.45,0,0,1,3.43,20.55c.42,4.82.6,9.41.64,13.56.11,9.74-.15,20.77-.15,20.77s25.55,0,36.71-.11c6.71-34.88-1.48-53.18-1.48-53.18l-9.12-3.12s-1.27-.13-1.91-.17a149.45,149.45,0,0,0-15.76.17c-1,.05-2,.13-3,.22C145.7,205.12,141.29,206,141.29,206Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.88,205.29a16.65,16.65,0,0,0,11.9,4.77,3.6,3.6,0,0,0,3.83-3.6,7.5,7.5,0,0,1-3.1-1.75c-2.13-2.1-1.6-5.15-.62-8l-9-9a50.15,50.15,0,0,1,.27,7.51h0C158,199.33,157.17,203.42,154.88,205.29Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2,195.23h0c1.48,4.31,4.26,9.11,9.31,9.47-2.13-2.1-1.6-5.15-.62-8l-9-9A50.15,50.15,0,0,1,158.2,195.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.09,180.28c.75,2.69.1,8.16-3.57,6.25S176.81,175.64,178.09,180.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.74,183.2c-.65,6.84-1.38,10.82,1.51,14.81,4.34,6,13.22,4.13,15.91-2.4,2.43-5.88,3.09-16.08-3.15-19.76A9.48,9.48,0,0,0,158.74,183.2Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.68,179.64,164,172s-8.13-.89-7.91,3.29c-4.6,2.08-3.22,12.16,2.73,15.82,3.41-2.54,3.77-11.94,3.77-11.94C162.89,179.32,163.28,179.49,163.68,179.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.24,188.44a6.42,6.42,0,0,0,2.59,4.24c1.87,1.32,3.59-.16,3.74-2.33.13-1.95-.69-5-2.88-5.45A3,3,0,0,0,155.24,188.44Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.76,186.62c-.09.55.14,1,.5,1.1s.72-.35.81-.91-.13-1-.5-1.09S168.85,186.07,168.76,186.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,187.55c-.09.55.14,1,.5,1.09s.72-.35.81-.9-.13-1-.5-1.1S175.11,187,175,187.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,187.53a19.08,19.08,0,0,0,2,4.95,3.3,3.3,0,0,1-2.7.05Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,194.21a7,7,0,0,0,.72.15.18.18,0,0,0,.19-.14.16.16,0,0,0-.14-.18,4.39,4.39,0,0,1-3.31-2.24.16.16,0,0,0-.22-.08.16.16,0,0,0-.08.22A4.61,4.61,0,0,0,169,194.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.15,184.32a.32.32,0,0,0,.32-.08,2.69,2.69,0,0,1,2.26-.78.33.33,0,0,0,.14-.64,3.32,3.32,0,0,0-2.86,1,.32.32,0,0,0,0,.46A.24.24,0,0,0,167.15,184.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,185.8a.41.41,0,0,0,.19,0,.32.32,0,0,0,.21-.41,3.25,3.25,0,0,0-2-2.17.34.34,0,0,0-.41.23.32.32,0,0,0,.22.4,2.54,2.54,0,0,1,1.6,1.74A.34.34,0,0,0,178.06,185.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.54,179.15s13.32,4.81,18.15.74-1-5.92-1-5.92,2,1.6.56,2.8c0,0-1.21-5.2-6.06-6.14a3.86,3.86,0,0,1,1.25,3.07,23.38,23.38,0,0,0-9-2.71C160.92,170.4,147,173.7,162.54,179.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,204.42a157.2,157.2,0,0,1,.84,27.39v0c-.72,12.4-9.82,53.76-9.82,53.76s-2.66-.62-3.4-1.95,3.68-19.92,3.28-33.41-4.31-43.64-4.31-43.64a44.42,44.42,0,0,1,9-1.83C149.79,204.63,151.26,204.49,152.87,204.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.48,283.65c.74,1.34,3.4,2,3.4,2s7-32.91,8.35-40.6a118.14,118.14,0,0,0,1.48-13.15s0,0,0,0c0-.48,0-.95.08-1.43a158.48,158.48,0,0,0-.88-25.65c0-.21,0-.32,0-.32-1.6.08-3.08.21-4.42.36a43.9,43.9,0,0,0-9,1.84s.9,7,1.9,15.76c0,.13,0,.26,0,.39.28,2.52.56,5.16.84,7.83h0c.52,5,1,10,1.26,14.29.13,2,.23,3.77.28,5.35C144.16,263.73,139.75,282.33,140.48,283.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,204.42a157.2,157.2,0,0,1,.84,27.39v0l-7.92-18.35,5-1.31L145.21,210l3.24-5.25C149.79,204.63,151.26,204.49,152.87,204.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,280.27l-1.15,1.16a434.23,434.23,0,0,0-6.55-47.05c-.24-1.28-.5-2.52-.74-3.7-4.67-22.49-8.86-26-9.13-26.24l3.47.58,6.29,1.08C186,225.14,188.89,280.27,188.89,280.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,280.27l-1.15,1.16a434.23,434.23,0,0,0-6.55-47.05c-.24-1.28-.5-2.52-.74-3.7-4.67-22.49-8.86-26-9.13-26.24l3.47.58,6.29,1.08C186,225.14,188.89,280.27,188.89,280.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.15,211.8l4.15,1.74s.83,11.23.15,17.14c-4.67-22.49-8.86-26-9.13-26.24l3.47.58a22.12,22.12,0,0,1,5.42,5.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,222.8a19.85,19.85,0,0,1-1,7.79c-.28-2.66-.57-5.31-.84-7.82A4.23,4.23,0,0,1,143.19,222.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,244.89c.45.1.91.17,1.37.23a27.87,27.87,0,0,0,7.38-.12,31.86,31.86,0,0,0,4.94-1.09c17.25-5.6,17.19-9.31,17.19-9.31s-11.21,1.07-17-1.24a9.63,9.63,0,0,1-3.58-3c-4.27-5.19-7.66-14.74-7.66-14.74s-1.17,1.43-2.72,3.65c-.65.91-1.35,2-2.06,3.08,0,.13,0,.26,0,.39.28,2.52.56,5.16.84,7.83h0C142.74,235.57,143.2,240.6,143.48,244.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47,228.62l.54,4.52c2.21,4.25,7.17.46,7.17.46l3.12-.86a2.41,2.41,0,0,0,1.59-2.69l-.35-3.16A2.52,2.52,0,0,0,184,224.5l-2.81.29a5,5,0,0,0-2.28.84Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45,206.61c-10.11,4.7,4,35.81,8,36.26,7.68.85,29-6.77,29-6.77l-1.35-8.59s-20.83,5.54-22.75,5c-2.47-.66-5.6-12.76-7.05-18.48A10.86,10.86,0,0,0,139.45,206.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45,206.61c-10.11,4.7,4,35.81,8,36.26,7.68.85,29-6.77,29-6.77l-1.35-8.59s-20.83,5.54-22.75,5c-2.47-.66-5.6-12.76-7.05-18.48A10.86,10.86,0,0,0,139.45,206.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.9,245h0l17.48-1.23a1.67,1.67,0,0,0,1.43-1.3L212,216a1,1,0,0,0-.25-.9.87.87,0,0,0-.71-.24l-17.51,1.24a1.68,1.68,0,0,0-1.43,1.31L187,243.83A.88.88,0,0,0,187.9,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.9,245h0l17.48-1.23a1.67,1.67,0,0,0,1.43-1.3L212,216a1,1,0,0,0-.25-.9.87.87,0,0,0-.71-.24l-17.51,1.24a1.68,1.68,0,0,0-1.43,1.31L187,243.83A.88.88,0,0,0,187.9,245Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,245l17.48-1.23a1.67,1.67,0,0,0,1.43-1.3L212,216a1,1,0,0,0-.25-.9l-17.47,1.24a1.67,1.67,0,0,0-1.43,1.3l-5.15,26.41A.91.91,0,0,0,187.94,245Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,229.51a1.86,1.86,0,1,0,2.17-1.87A2,2,0,0,0,199.34,229.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.52,230.13l-1.19,4.33c-2.57,4.42-6.18,2-6.18,2l-2.52-.14c-.86,0-1.24-1-.92-2.16l.81-3a3.79,3.79,0,0,1,2.58-2.77l2.34-.33a2.79,2.79,0,0,1,1.81.29Z",
    style: {
      fill: "#b55b52"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceI);
export default __webpack_public_path__ + "static/media/financeI.95d6cab292067d2d925390b7848b72b9.svg";
export { ForwardRef as ReactComponent };